import React from 'react'

/*

Renders a legacy beaker image that's attached to a break / step

(for now just spits out an img tag)

image parameter takes the shape:
    "image": {
        "id": "76942d14-f95f-45c5-b2c8-73e41a823005",
        "name": "iStock-1131049630-personalityQuestion",
        "source": "iStock",
        "link": "",
        "altAttribute": "airplane flying through sunset"
    }


*/

export const legacyImageURL = image => {
  if (!image) {
    return '' // not sure what a good response is for this
  }

  return `${process.env.SITE_ASSET_URL}/${image.id}`
}

const LegacyImage = ({ image, setInteracted, style }) => {
  if (!image) {
    return false
  }

  return (
    <img
      style={{ width: `100%`, ...style }}
      src={`${process.env.SITE_ASSET_URL}/${image.id}`}
      alt={image.alt || image.name}
      onClick={() => setInteracted && setInteracted(true)}
    />
  )
}

export default LegacyImage
